import {defineStore} from "pinia";
import * as BlogService from "@/services/blog.service";
import {computed, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useDestinationStore} from "@/stores/destinationStore";
import {useWindowSize} from "@vueuse/core";


export const useBlogStore = defineStore('articles', () => {
    const loading = ref(false);
    const allArticles = ref([]);
    const destinationStore = useDestinationStore();
    const categoryOptions = ['All Categories', 'Destination', 'Travel', 'Itinerary', 'Inspiration', 'Corporate']
    const currentPage = ref(1);
    const totalPages = ref(0);
    const { width } = useWindowSize();
    const articlesPerPage = computed(() => (width.value >= 1336 ? 9 : 8));



    const destinationOptions = computed(() =>
        destinationStore.allDestinations.map(dest => dest.generalLocation)
    );

    // Filter state
    const selectedCategory = ref<string | null>(null);
    const selectedDestinations = ref<string[]>([]);
    const sortOptions = ['Latest', 'Featured']
    const selectedSort = ref(sortOptions[0]);

    const router = useRouter();
    const route = useRoute();

    const filteredArticles = computed(() => {
        let results = [...allArticles.value];

        // Sorting
        switch (selectedSort.value) {
            case 'Latest':
                results.sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime());
                break;
            case 'Featured':
                results.sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime());

                break;
        }

        return results;
    });


    const query = computed(() => {
        const q: Record<string, string> = {};
        if (selectedSort.value) q.sort = selectedSort.value;
        return q;
    });

    function updateRouteQuery() {
        router.replace({
            path: route.path,
            query: query.value,
        });
    }

    function setFromQuery(query: Record<string, any>) {
        selectedSort.value = query.sort || sortOptions[0];
    }


    async function getAllArticles(slug: string, page: number, size: number) {
        loading.value = true;

        try {
            const response = await BlogService.getChildren(slug, page, size);
            const data = response.data;
            // totalPages.value = data.pages || totalPages;
            // Only set totalPages once, or if it's undefined
            totalPages.value ||= data.pages;


            const sorted = [...data.results].sort((a, b) =>
                new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
            );
            console.log("sorted: ", sorted)

            allArticles.value = sorted;


            currentPage.value = data.currentPage;
            // totalPages.value = data.pages;

        } catch (error) {
            allArticles.value = [];
        } finally {
            loading.value = false;
        }
    }



    const totalItems = computed(() => {
        return totalPages.value > 0 ? totalPages.value * articlesPerPage.value : 0;
    });


    watch(
        currentPage,
        (newPage, oldPage) => {
            if (newPage !== oldPage) {
                getAllArticles('travel-inspiration', newPage, articlesPerPage.value);
            }
        },
        { flush: 'post' }
    );


    return {
        allArticles,
        loading,
        selectedCategory,
        selectedDestinations,
        selectedSort,
        sortOptions,
        query,
        getAllArticles,
        updateRouteQuery,
        setFromQuery,
        categoryOptions,
        destinationOptions,
        filteredArticles,
        articlesPerPage,
        currentPage,
        totalPages,
        totalItems

    };

});
